import { ReactNode } from 'react';
import { Block, Title, Separator } from './view';

type SectionProps = {
    title: string;
    withSeparatorBefore?: boolean;
    children: ReactNode;
};

export const Section = ({ title, withSeparatorBefore, children }: SectionProps) => (
    <>
        {withSeparatorBefore && <Separator />}
        <Block>
            <Title variant="body2" colorVariant="second">
                {title}
            </Title>
            {children}
        </Block>
    </>
);

Section.displayName = 'Section';
